/** Property desk filters — CoStar/Homsie: filter closed, never delete. */

export const CLOSED_STATUSES = new Set(['completed', 'delivered', 'archived', 'cancelled']);

export function isClosedProperty(prop) {
  if (prop?.closed === true) return true;
  return CLOSED_STATUSES.has(String(prop?.status || '').toLowerCase());
}

export function deskFilterTabs(properties = []) {
  const open = properties.filter(p => !isClosedProperty(p)).length;
  const closed = properties.filter(p => isClosedProperty(p)).length;
  return [
    { id: 'Open', count: open },
    { id: 'Closed', count: closed },
    { id: 'All', count: properties.length },
  ];
}

export function filterByDeskTab(properties, tab) {
  if (tab === 'Closed') return properties.filter(isClosedProperty);
  if (tab === 'All') return properties;
  return properties.filter(p => !isClosedProperty(p));
}

export function initialDeskTabFromSearch(search) {
  const q = new URLSearchParams(search || '');
  const f = (q.get('filter') || q.get('closed') || '').toLowerCase();
  if (f === 'closed' || f === '1' || f === 'true') return 'Closed';
  if (f === 'all') return 'All';
  return 'Open';
}
